import Vuex from 'vuex';
import Vue from 'vue';
import app from './modules/app';
import nav from './modules/nav';
import review from './modules/review';
import reviewSettings from './modules/review-settings';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  modules: {
    app,
    nav,
    review,
    reviewSettings,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js